import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';

const { FiClock, FiTrendingUp, FiTarget, FiCheckCircle, FiActivity } = FiIcons;

function StatsCards({ entries }) {
  // Filter for completed entries only for impact stats
  const completedEntries = entries.filter(e => 
    e.status === 'completed' || (e.timeAfter !== null && e.timeAfter !== undefined && e.timeAfter !== '')
  );

  const totalTimeSaved = completedEntries.reduce((sum, entry) => sum + entry.timeSaved, 0);
  const totalStepsReduced = completedEntries.reduce((sum, entry) => sum + entry.stepsReduced, 0);
  
  const avgConfusionReduction = completedEntries.length > 0 
    ? completedEntries.reduce((sum, entry) => sum + entry.confusionReduction, 0) / completedEntries.length 
    : 0;

  const stats = [
    {
      title: 'Active Systems',
      value: entries.length - completedEntries.length,
      icon: FiActivity,
      color: 'orange',
      description: 'Tasks currently being optimized'
    },
    {
      title: 'Time Saved',
      value: `${totalTimeSaved} min`,
      icon: FiClock,
      color: 'blue',
      description: 'From completed sprints'
    },
    {
      title: 'Steps Reduced',
      value: totalStepsReduced,
      icon: FiTrendingUp,
      color: 'green',
      description: 'Total process simplification'
    },
    {
      title: 'Avg Clarity Gain',
      value: `+${avgConfusionReduction.toFixed(1)}`,
      icon: FiTarget,
      color: 'purple',
      description: 'Reduction in confusion level'
    }
  ];

  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      icon: 'bg-blue-100 text-blue-600',
      text: 'text-blue-600'
    },
    green: {
      bg: 'bg-green-50',
      icon: 'bg-green-100 text-green-600',
      text: 'text-green-600'
    },
    purple: {
      bg: 'bg-purple-50',
      icon: 'bg-purple-100 text-purple-600',
      text: 'text-purple-600'
    },
    orange: {
      bg: 'bg-orange-50',
      icon: 'bg-orange-100 text-orange-600',
      text: 'text-orange-600'
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => {
        const colors = colorClasses[stat.color];
        return (
          <motion.div
            key={stat.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className={`${colors.bg} p-6 rounded-xl border border-gray-200 hover:shadow-md transition-shadow`}
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`${colors.icon} p-3 rounded-lg`}>
                <SafeIcon icon={stat.icon} className="text-xl" />
              </div>
            </div>
            <div className="space-y-2">
              <p className="text-sm font-medium text-gray-600">{stat.title}</p>
              <p className={`text-3xl font-bold ${colors.text}`}>{stat.value}</p>
              <p className="text-xs text-gray-500">{stat.description}</p>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}

export default StatsCards;